export type AnalyticsEvent =
  | 'discovery_started'
  | 'images_submitted'
  | 'style_card_regenerated'
  | 'style_card_approved'
  | 'recommendations_viewed'
  | 'fragrance_saved'
  | 'fragrance_marked_tested'
  | 'feedback_submitted'
  | 'retailer_link_clicked';

export interface Analytics {
  track(event: AnalyticsEvent, properties?: Record<string, string | number | boolean>): void;
}

export class NoOpAnalytics implements Analytics {
  track() {
    // Intentionally empty. The MVP installs no tracking vendor.
  }
}

export const analytics: Analytics = new NoOpAnalytics();
